import { useContext, useState } from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { decryptURL } from 'utils/functions';
import { useNavigate, useParams } from 'react-router-dom';
import { DropsContext } from 'contexts/DropsContext';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import Button from 'components/Button';
import Input from 'components/Input';
import api from 'services/api';

const Bling = ({ id, integra_access_id, Header }) => {
  const { hash } = useParams();
  const navigate = useNavigate();
  const decrypt = hash ? decryptURL(hash) : null;
  const defaultValues = {
    id,
    integra_access_id,
    produto_id: decrypt?.produto_id || null,
    codigo: decrypt?.codigo || '',
    descricaocurta: decrypt?.descricao || '',
  };
  const [loading, setLoading] = useState(false);
  const { drops } = useContext(DropsContext);
  const { control, handleSubmit } = useForm({ defaultValues });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await api.post(`/Integracoes/Bling/Produto`, data);
      navigate(-1);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Header />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <VirtualDrop
            name="produto_id"
            control={control}
            label="Produto"
            options={drops?.Produto?.filter((f) =>
              [
                '00-Mercadoria para revenda',
                '04-Produto acabado',
                '05-Subproduto',
                '06-Produto intermediário',
              ]?.includes(f?.tipolinha)
            )}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Input name="codigo" control={control} label="Código" />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="descricaocurta"
            control={control}
            label="Descrição Curta"
            multiline
            rows={10}
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
            loading={loading}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Bling;
